import _ from 'lodash'
import { getOrderTypes } from 'shared-js/settings-services/order-types-service'

export function cleanPrintingRouting (settingsBlob) {
  for (const printingSettings of _.values(_.get(settingsBlob, 'printingRouting', []))) {
    cleanPrintingRoutingSettings(printingSettings, settingsBlob)
  }
}

export function cleanPrintingRoutingSettings (printingSettings, settingsBlob) {
  const stations = settingsBlob.stations.map(next => next.id)

  for (const station of _.values(printingSettings.stations)) {
    if (!stations.includes(station.stationId) && station.stationId !== 'online' && station.stationId !== 'curbside') {
      delete printingSettings.stations[station.stationId]
    } else {
      cleanPrintingRoutingStation(station, settingsBlob)
    }
  }
}

export function cleanPrintingRoutingStation (station, settingsBlob) {
  const orderTypes = [
    ...getOrderTypes(settingsBlob).map(it => it.code),
    'credit_receipt',
    'local',
    'dispatch'
  ]

  for (const orderType of _.values(station.orderTypes)) {
    if (!orderTypes.includes(orderType.orderTypeCode)) {
      delete station.orderTypes[orderType.orderTypeCode]
    } else {
      cleanPrintingRoutingOrderType(orderType, settingsBlob)
    }
  }
}

export function cleanPrintingRoutingOrderType (orderType, settingsBlob) {
  const availablePrinters = _.get(settingsBlob, 'printing.printers', []).map(it => it.id)
  const availableScreens = _.get(settingsBlob, 'displays', []).map(it => it.id)

  const cleanIt = (root, available) => {
    if (root) {
      root.selected = root.selected.filter(it => available.includes(it))
    }
  }

  cleanIt(orderType.kitchenPrinting, availablePrinters)
  cleanIt(orderType.customerReceipt, availablePrinters)
  cleanIt(orderType.labelPrinting, availablePrinters)
  cleanIt(orderType.KPS, availableScreens)
}
